import React from 'react';
import { Prompt } from '../Prompt/Prompt.component';

interface GradeChangeInLeadingCriterioPromptProps {
  dependentCriterionsCaptions: string;
  onCancel?: () => void;
  onConfirm?: () => void;
}

const GradeChangeInLeadingCriterioPrompt: React.FC<GradeChangeInLeadingCriterioPromptProps> = (props) => {
  return (
    <Prompt
      type="confirmation"
      open={true}
      size="sm"
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
      cancelButtonText="ANULUJ"
      mainActionButtonText="TAK"
      mainText={<>Czy na pewno chcesz zmienić punktację?</>}
      subTexts={[
        {
          text: (
            <>
              Zostanie usunięta punktacja w co najmniej <br />
              jednym kryterium zależnym {props.dependentCriterionsCaptions}
            </>
          ),
        },
      ]}
    />
  );
};

export default GradeChangeInLeadingCriterioPrompt;
